<div style="overflow-x:auto; overflow-y:hidden;">
      <ag-grid-angular #kvGrid
        style="width: 100%; height: 350px;"
        [rowData]="gridData"
        [columnDefs]="columns"
        [defaultColDef]="defaultColDef"
        [pagination]="false"
        [rowSelection]="gridOptions.rowSelection"
        (selectionChanged)="onSelectionChanged()"
        (gridReady)="onGridReady($event)"
      />
</div>
<div>
  <span>Selected: {{ selectedRows.length }}</span>
  <span [hidden]="!inprogress"> {{LOCALIZATION.loading}} <i class="fas fa-spinner fa-spin fa-fw"></i></span>
</div>
